import React, { useState, useEffect } from "react";
import moment from "moment";
import Api from "shared/resources/Api";
import { Container, Row, Col, Modal, ModalBody } from "reactstrap";
import "react-image-lightbox/style.css";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";

const OvitrampReport = () => {
  useEffect(() => {
    moment.updateLocale("pt-br", {
      week: {
        dow: 0,
        doy: 3,
      },
    });
  }, []);

  const listCasos = {
    CENTRAL: 0,
    NORTE: 0,
    SUL: 0,
    LESTE: 0,
    OESTE: 0,
    RURAL: 0,
    DISTRITO: 0,
    "NAO IDENTIFICADO": 0,
  };

  const [selectedWeek, setSelectedWeek] = useState(moment().week());
  const [selectedYear, setSelectedYear] = useState(moment().year());

  const getData = async (type) => {
    let data_inicio = null;
    let data_fim = null;
    if (selectedWeek && selectedYear) {
      data_inicio = moment()
        .year(selectedYear)
        .week(selectedWeek)
        .startOf("week")
        .format("DD-MM-YYYY");
      data_fim = moment()
        .year(selectedYear)
        .week(selectedWeek)
        .endOf("week")
        .format("DD-MM-YYYY");
    }

    let url = Api.baseURL + "/ovitrampa/relatorio/movimentos";
    if (data_inicio && data_fim) {
      url += `?data_inicio=${encodeURIComponent(
        data_inicio
      )}&data_fim=${encodeURIComponent(data_fim)}`;
    }

    let response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });

    let body = await response.json();
    if (body.data && body.data.length > 0) {
      let porBairro = {};
      let porSetor = { ...listCasos };

      for await (let item of body.data) {
        const setor = item.NM_SETOR?.toUpperCase() || "NAO IDENTIFICADO";
        if (!porSetor[setor]) {
          porSetor[setor] = { ovos: 0, casos: 0 };
        }
        if (porSetor.hasOwnProperty(setor)) {
          porSetor[setor]['ovos']+= item.TOTAL_OVOS;
          porSetor[setor]['casos'] += 1;
        } else {
          porSetor["NAO IDENTIFICADO"]['ovos']+= item.TOTAL_OVOS;
          porSetor["NAO IDENTIFICADO"]['casos'] += 1;
        }

        const bairro = item.NM_BAIRRO;

        if (!porBairro[bairro]) {
          porBairro[bairro] = { ovos: 0, casos: 0 };
        }

        if (!porBairro[bairro]) {
          porBairro[bairro] = 0;
        }

        porBairro[bairro]['ovos'] += item.TOTAL_OVOS;
        porBairro[bairro]['casos'] = (porBairro[bairro]['casos'] || 0) + 1;
      }


      if (type === "setor") {
        const dadosFormatados = Object.entries(porSetor).map(
          ([Setor, registro]) => ({
            Setor: Setor,
            Casos: registro['casos'],
            Ovos: registro['ovos']
          })
        );
        downloadExcel(dadosFormatados, "Relatorio_por_setor");
      }
      if (type === "analitico") {
        const relatorio = body.data.map((item) => ({
          ...item,
          SEMANA_EPIDEMIOLOGICA: `Semana ${selectedWeek}`,
        }));
        downloadExcel(relatorio, "Relatorio_analitico");
      }
      if (type === "bairro") {
        const dadosFormatados = Object.entries(porBairro).map(
          ([bairro, registro]) => ({
            Bairro: bairro,
            Casos:registro['casos'],
            Ovos: registro['ovos'],
          })
        );
        downloadExcel(dadosFormatados, "Relatorio_por_bairro");
      }
      

      return true;
    } else {
      Swal.fire(
        "Sem dados Para o período selecionado",
        "",
        "info"
      );
      return;
    }
  };

  const downloadExcel = (dados, name = "Relatorio") => {
    const arrayDados = Array.isArray(dados)
      ? dados
      : Object.entries(dados).map(([key, value]) => ({ key, value }));

    if (!arrayDados.length) {
      Swal.fire("Sem dados Para o período selecionado", "", "info");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(arrayDados);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Ovitrampas");
    XLSX.writeFile(wb, name + ".xlsx");
  };

  const generateYearOptions = () => {
    const currentYear = moment().year();
    const options = [];
    for (let i = 2024; i <= currentYear; i++) {
      options.push(
        <option key={i} value={i}>
          {" "}
          {i}
        </option>
      );
    }
    return options;
  };

  const generateWeekOptions = () => {
    const weeksInYear = moment().year(selectedYear).weeksInYear();
    const options = [];
    for (let i = 1; i <= weeksInYear; i++) {
      options.push(<option key={i} value={i}>{`Semana ${i}`}</option>);
    }
    return options;
  };

  const startDate = moment()
    .year(selectedYear)
    .week(selectedWeek)
    .startOf("week")
    .format("DD/MM/YYYY");
  const endDate = moment()
    .year(selectedYear)
    .week(selectedWeek)
    .endOf("week")
    .format("DD/MM/YYYY");
  const dateRangeText = `Período: ${startDate} e ${endDate}`;

  return (
    <>
      <Container className="mb-7 mt-5" fluid>
        <div className="mb-3" style={{ height: "6vw" }}></div>

        <div className="mb-3 d-flex align-items-start" style={{ gap: 16 }}>
          <div style={{ flex: 1 }}>
            <label className="form-control-label" htmlFor="select-year">
              Ano Epidemiológico
            </label>
            <select
              id="select-year"
              className="form-control"
              value={selectedYear}
              onChange={(event) => {
                setSelectedYear(parseInt(event.target.value, 10));
              }}
            >
              {generateYearOptions()}
            </select>
          </div>

          <div style={{ flex: 1 }}>
            <label className="form-control-label" htmlFor="select-week">
              Semana Epidemiológica
            </label>
            <select
              id="select-week"
              className="form-control"
              value={selectedWeek}
              onChange={(event) => {
                setSelectedWeek(parseInt(event.target.value, 10));
              }}
            >
              {generateWeekOptions()}
            </select>
            <small className="form-text text-muted mt-1">{dateRangeText}</small>
          </div>
          <div style={{ flex: 1 }}></div>
        </div>
        <div className="mb-3" style={{ height: "1vw" }}>
        </div>
           <small className="form-text text-muted mt-1">Selecione o relatório:</small>

        <div className="d-flex flex-wrap gap-2 mt-2 mb-5">
          <button
            className="btn btn-primary"
            onClick={() => getData("analitico")}
          >
            Analítico
          </button>

          <button
            className="btn btn-primary"
            onClick={() => getData("setor")}
          >
            Por Setor
          </button>


          <button
            className="btn btn-primary"
            onClick={() => getData("bairro")}
          >
            Por Bairro
          </button>
        </div>
      </Container>
    </>
  );
};

export default OvitrampReport;
